<template lang="html">
    <div class="content">
        <template>
            <div class="numbers" v-if="step == 1">
                <div>
                    <v-btn flat @click="updateVersion('-')" :disabled="version <= 1"><v-icon>remove</v-icon></v-btn>
                    <div>{{version}}</div>
                    <v-btn flat @click="updateVersion('+')"><v-icon>add</v-icon></v-btn>
                </div>
            </div>

            <!-- open a modal with a loader the time of the pdf is generated -->
            <div class="loader" v-if="step==2">
                <img src="../../../assets/img/grid_loader.svg" />
                <p>Changement de version</p>
            </div>

        </template>
    </div>
</template>

<script>
    import moment from 'moment'
    moment.locale('fr')
    export default {
        data() {
            return {
                title:          'Changer la version du produit',
                icon:           'sync',
                moment,
                step: 1,
                version: 0,

            }
        },

        methods: {
            onClose() {
                this.$eventHub.$emit('close-modal')
            },

            onValidate() {
                this.step++
                this.axios.put(`/api/products/${this.$store.state.single.data.id}`, {version: this.version})
                .then(response => {
                    this.$store.dispatch('updateSingleData', { key:'version', value:this.version })
                    this.$store.dispatch('updateSingleData', { key:'files_count', value:this.$store.state.single.data.files_count + 1 })
                    this.$eventHub.$emit('reload-list')
                    this.onClose()
                })
            },
            updateVersion(action) {
                if(action == '-'){
                    this.version--
                } else {
                    this.version++
                }
            }
        },
        mounted(){
            this.version = this.$store.state.single.data.version
        }

    }
</script>

<style lang="stylus" scoped>

    div.content
        padding 1rem 4rem

    .numbers
        width: 100%
        display: flex
        justify-content: center
        & > div
            display: flex
            justify-content: center
            align-items: center

    .loader
        display flex
        flex-direction column
        align-items center
        width 100%
        padding 3rem 0

        img
            margin 0 0 3rem

</style>



// WEBPACK FOOTER //
// src/views/products/single/UpdateVersion.vue